import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UtilitiesProvider } from 'providers/utilities';

@Pipe({
  name: 'translateCustom'
})
@Injectable()
export class TranslateCustomPipe extends TranslatePipe implements PipeTransform {

  transform(value: any): any {
    // TODO: Se sigue trbajando en esta solucion para marcar los registro que no se encuentran en algun tipo de log
    const trans = super.transform(value)
    if (this.lastKey === this.value) {
      console.log(`*** Posiblemente no se encuentra en el diccionario de i18n`, `background: green; color: white; display: block;`, this.lastKey);
    }
    return trans;
  }


}



// WEBPACK FOOTER //
// ./src/pipes/custom-translate.ts